import { makeStyles } from '@material-ui/core/styles'

import { colors } from '@galo-monitor/styles'

const useStyles = makeStyles(() => ({
  root: {
    fontSize: '0.8rem',
    color: colors.green2
  },
  active: {
    fontSize: '0.8rem',
    color: colors.lightGrey4
  }
}))

export default useStyles
